import React from "react";
import 'react-circular-progressbar/dist/styles.css';


const SectionSeven: React.FC<any> = () => {
    return (
        <>
            <div className="drive-section-five">
                <div className="container-fluid">
                    

                    <div className="col-md-12">
                        <div className="sec-width">
                            <div className="row">
                                <div className="col-md-6 left-side">
                                    <div className="css-xl4503">
                                        <div className="pt-4">
                                            <div className="title">
                                                <h3><span>Boost your AOV with dynamic discount options</span></h3>
                                            </div>
                                            <div className="descr">
                                                <p>Incentivise your shoppers to increase prepaid orders</p>
                                                <ul>
                                                    <li>Offer 200+ dynamic discounts over & above Shopify</li>
                                                    <li>Prepaid payment discounts</li>
                                                    <li>Gift cards on Shopify</li>
                                                    <li>Free gifts over and above discounts</li>
                                                    <li>Extensive loyalty and reward partnerships</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 right-side">
                                   <img src="/assets/images/kwikcheckout/dynamic-discount.svg" />
                                </div>

                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
export default SectionSeven;